import { Amount } from '@/components/atoms/Amount/Amount'
import { CopiableLink } from '@/components/atoms/CopiableLink/CopiableLink'
import { StatsRow } from '@/components/atoms/StatsRow/StatsRow'
import { EXPLORERS, INJ_DENOM } from '@/constants/constants'
import { Bet } from '@/context/JackpotProvider'
import { formatAmount } from '@/helpers/formatAmount'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  SimpleGrid,
  Button,
  useMediaQuery,
} from '@chakra-ui/react'
import { getEthereumAddress } from '@ninjablaze/sdk-ts'
import { useTranslation } from 'next-i18next/pages'

export default ({ onClose, player }: { onClose: () => void; player: Bet }) => {
  const { t } = useTranslation()
  const date = new Date(parseInt(player.date))
  const [isLargerThanMd] = useMediaQuery('(min-width: 768px)')

  return (
    <Modal size={'lg'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalHeader pb={2} fontSize="xl" fontWeight="700">
          {t('Statistics.tx-details')}
        </ModalHeader>
        <ModalCloseButton onClick={onClose} size="sm" />
        <ModalBody pb={5}>
          <SimpleGrid columns={2} gap={4}>
            <StatsRow
              name={t('common.amount')}
              value={<Amount iconSize={'18px'} denom={INJ_DENOM} value={formatAmount(player.amount)} />}
            />
            <StatsRow
              name={t('common.date')}
              value={
                <Text as={'span'} fontSize={{ base: 'xs', md: 'sm' }}>
                  {date.toLocaleString()}
                </Text>
              }
            />
          </SimpleGrid>
          <StatsRow
            name={t('common.player-address')}
            value={
              <CopiableLink
                trimmedLength={isLargerThanMd ? 16 : 24}
                maxLength={isLargerThanMd ? 48 : 32}
                link={`${EXPLORERS.INJECTIVE_WALLETS}${player.address}/`}
                value={getEthereumAddress(player.address)}
              />
            }
          />
          <StatsRow
            name={t('common.block-number')}
            value={
              <CopiableLink link={`${EXPLORERS.INJECTIVE_BLOCKS}${player.block}/`} value={player.block.toString()} />
            }
          />
          <StatsRow
            name={t('common.txhash')}
            value={
              <CopiableLink
                trimmedLength={24}
                link={`${EXPLORERS.INJECTIVE_TRANSACTIONS}${player.tx_hash}/`}
                value={player.tx_hash}
              />
            }
          />
          <a target={'_blank'} href={`${EXPLORERS.INJECTIVE_TRANSACTIONS}${player.tx_hash}/`}>
            <Button w={'full'} rounded={'xl'}>
              {t('common.view-in-explorer')}
            </Button>
          </a>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
